module.exports = __webpack_public_path__ + "static/img/count-down-bg-big-size.887bb7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/count-down-bg-big-size.jpg
// module id = t2l3
// module chunks = 1